module.exports = __webpack_public_path__ + "img/12.3465bf82.jpg";